<template>
  <v-flex class="add-to-home" v-if="showInstallBanner">
    <v-card flat tile width="100%" class="primary" dark>
      <v-btn class="mx-2" fab dark small @click="close()">x</v-btn>
      Do you want to add this app to your home screen?
      <v-btn @click.prevent="install" color="secondary">ADD</v-btn>
    </v-card>
  </v-flex>
</template>
<script>
// src/components/InstallPrompt.vue
let installEvent;
export default {
  name: "installPrompt",
  data() {
    return {
      showInstallBanner: false
    };
  },
  created() {
    window.addEventListener("beforeinstallprompt", e => {
      e.preventDefault();
      installEvent = e;
      this.showInstallBanner = true;
    });
  },
  methods: {
    close(){
      this.showInstallBanner = false;
    },
    install() {
      this.showInstallBanner = false;
      installEvent.prompt();
      installEvent.userChoice.then(() => {
        installEvent = null;
      });
    }
  }
};
</script>

<style>
.add-to-home {
  position: absolute;
  bottom: 0;
  width: 100%;
}
</style>